<template>
  <div id="SBTi">
    <SectionHeroSBTi />
    <SectionTrust />
    <SectionConfidence />
    <SectionAvoidPitfalls />
    <SectionSBTiPartner />
    <SectionSBTiRoadmap />
    <SectionTrackRecord />
    <SectionSBTiPricing />
    <SectionSBTiFAQs />
  </div>
</template>

<script setup lang="ts">
import SectionTrust from '@/views/components/sections/SectionTrust.vue'
import SectionHeroSBTi from './sections/SectionHeroSBTi.vue'
import SectionConfidence from './sections/SectionConfidence.vue'
import SectionAvoidPitfalls from './sections/SectionAvoidPitfalls.vue'
import SectionSBTiPartner from './sections/SectionSBTiPartner.vue'
import SectionSBTiRoadmap from './sections/SectionSBTiRoadmap.vue'
import SectionTrackRecord from '@/views/components/sections/SectionTrackRecord.vue'
import SectionSBTiPricing from './sections/SectionSBTiPricing.vue'
import SectionSBTiFAQs from './sections/SectionSBTiFAQs.vue'
import {
  useSeo,
  getBreadcrumbStructuredData,
  getFAQStructuredData,
} from '@/composables/useSeo'
import { getSeoConfig } from '@/config/seo'

// FAQ Data for structured data
const faqData = [
  {
    question: 'What are Science Based Targets (SBTi)?',
    answer:
      'Science Based Targets (SBTi) are emissions reduction targets aligned with climate science to limit global warming to 1.5°C above pre-industrial levels. They provide companies with a clearly defined pathway to reduce greenhouse gas emissions.',
  },
  {
    question: 'How long does SBTi validation take?',
    answer:
      'SBTi validation typically takes 3-6 months from submission to approval. Our consulting accelerates preparation time by helping you model accurate targets, gather required data, and prepare comprehensive documentation before submission.',
  },
  {
    question: "What's the difference between near-term and net-zero targets?",
    answer:
      'Near-term targets cover 5-10 years and require minimum 42% reduction in Scope 1 and 2 emissions. Net-zero targets extend to 2050 and require at least 90% reduction across all scopes, with residual emissions neutralized through carbon removal.',
  },
  {
    question: 'Do I need to include Scope 3 in my SBTi targets?',
    answer:
      'Yes, if your Scope 3 emissions represent more than 40% of total emissions, you must set Scope 3 targets. Our platform helps you calculate, model, and track all 15 Scope 3 categories to ensure compliance.',
  },
  {
    question: "What is Sustainalyse's SBTi approval rate?",
    answer:
      'Our clients achieve a 95% SBTi approval rate on first submission. We provide expert guidance on target calculation, scenario modeling, FLAG sector requirements, and comprehensive documentation to ensure validation success.',
  },
]

// SEO Configuration with FAQ schema
useSeo(getSeoConfig('sbti'), [
  getBreadcrumbStructuredData([
    { name: 'Home', url: 'https://sustainalyse.com/' },
    { name: 'SBTi Target Setting', url: 'https://sustainalyse.com/sbti' },
  ]),
  getFAQStructuredData(faqData),
])
</script>

<style lang="scss" scoped>
#SBTi {
  min-height: 100vh;
  background-color: $color-ui-gray-cool-50;
}
</style>
